import React from 'react';
import './App.css';
import Index from './Home'
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Article1 from './Article1';
import Article2 from './Article2';
import Article3 from './Article3';
import Article4 from './Article4';
import Article5 from './Article5';
import Article6 from './Article6';
import Article7 from './Article7';
import Article8 from './Article8';
import Article9 from './Article9';
import Terms from './Terms';
import AboutUs from './AboutUs';
import Privacy from './Privacy';
import { UI_DESIGN, UI_ISSUE, UI_SLIDE_STRUCTURE, UI_TOP_MESSAGE, UI_BOTTOM, UI_SUMMARY, UI_PRESENTATIONS, UI_PROFESSIONAL_BOOKS, UI_EPILOGUE } from './consts';
import ReactGA from "react-ga4";
import { GA_ID } from './consts';


ReactGA.initialize(GA_ID);

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path={`/`} element={<Index />} />
        {/* <Route path={`/sign-in/`} element={<SignIn />} />
        <Route path={`/sign-up/`} element={<SignUp />} /> */}
        {/* <Route path={`/account/`} element={<SelfService />} /> */}
        <Route path={`/about`} element={<AboutUs />} />
        <Route path={UI_ISSUE} element={<Article1 />} />
        <Route path={UI_SLIDE_STRUCTURE} element={<Article2 />} />
        <Route path={UI_TOP_MESSAGE} element={<Article3 />} />
        <Route path={UI_DESIGN} element={<Article4 />} />
        <Route path={UI_BOTTOM} element={<Article5 />} />
        <Route path={UI_SUMMARY} element={<Article6 />} />
        <Route path={UI_PRESENTATIONS} element={<Article7 />} />
        <Route path={UI_PROFESSIONAL_BOOKS} element={<Article8 />} />
        <Route path={UI_EPILOGUE} element={<Article9 />} />
        <Route path={`/terms`} element={<Terms />} />
        <Route path={`/privacy`} element={<Privacy />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
